import { Injectable, inject, NgZone } from '@angular/core';
import { fromEvent, merge, Subscription, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private authService = inject(AuthService);
  private ngZone = inject(NgZone);

  private readonly IDLE_TIMEOUT = 10 * 60 * 1000; // 10 minutes in milliseconds
  private idleSubscription?: Subscription;

  startMonitoring(): void {
    this.stopMonitoring();

    // Use NgZone.runOutsideAngular for better performance since these events fire frequently
    this.ngZone.runOutsideAngular(() => {
      const activityEvents$ = merge(
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'click'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'wheel'),
        fromEvent(document, 'scroll'),
        fromEvent(document, 'touchstart'),
      );

      this.idleSubscription = activityEvents$
        .pipe(
          // Reset the timer on any activity event
          switchMap(() => timer(this.IDLE_TIMEOUT)),
        )
        .subscribe(() => {
          // Timer reached, check if user is authenticated before logging out
          if (this.authService.isAuthenticated()) {
            this.ngZone.run(() => {
              console.warn(`User idle for ${this.IDLE_TIMEOUT / 60000} minutes. Logging out.`);
              this.authService.logout();
            });
          }
        });
    });
  }

  stopMonitoring(): void {
    if (this.idleSubscription) {
      this.idleSubscription.unsubscribe();
      this.idleSubscription = undefined;
    }
  }
}
